import React from "react";
import ReactDOM from "react-dom/client";
import "./custom.scss";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@shared/i18n/i18n";
import { captureInstallPrompt } from "@shared/push/installPrompt";
import { registerServiceWorker } from "@shared/push/pushService";
import { captureTenantFromUrl } from "@shared/branding/tenantBranding";

// Chrome announces installability before the app has rendered anything.
captureInstallPrompt();

// ?m=<tenant> must be read before the first render: useToken drops the whole
// query once it finds an auth_token.
captureTenantFromUrl();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Web push for training reminders (public/sw.js). Skipped quietly where
// service workers are unavailable.
registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
